import React from 'react';

const PayrollTab = ({ register, watch,overtimeBasedOn,commissionRateType }) => {
  const paySalesCommissions = watch('pay_sales_commissions');
  const calculateOvertimeBasedOn = watch('overtime_based_on_id');
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {/* Employee ID */}
      {/* <div>
        <label className="block text-sm font-medium text-gray-700">Employee ID</label>
        <input
          type="text"
          {...register('employeeId')}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          placeholder="Enter Employee ID"
        />
      </div> */}

      {/* Exclude from Hours Worked Report */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Exclude User From Hours Worked By Employee Report</label>
        <div className="mt-1">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              {...register('exclude_from_hours_worked_report')}
              className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
            />
            <span className="ml-2 text-sm text-gray-600">Yes</span>
          </label>
        </div>
      </div>

      {/* Regular Rate */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Regular Rate</label>
        <div className="mt-1 relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">$</span>
          </div>
          <input
            type="number"
            step="0.01"
            {...register('regular_rate')}
            className="appearance-none block w-full pl-7 pr-12 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="0.00"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">/hour</span>
          </div>
        </div>
      </div>

      {/* Sales Commissions */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Pay Sales Commissions</label>
        <div className="mt-1">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              {...register('pay_sales_commissions')}
              className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
            />
            <span className="ml-2 text-sm text-gray-600">Yes</span>
          </label>
        </div>
      </div>

      {/* Commission Rate Type (only shown if paySalesCommissions is true) */}
      {paySalesCommissions && (
        <div>
          <label className="block text-sm font-medium text-gray-700">Rate Type</label>
          <select
            {...register('commission_rate_type')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
          >
            <option value="" className='text-gray-400'>Select Rate Type</option>
            {commissionRateType?.map(commission => (
              <option key={commission.id} value={commission.id}>{commission.name}</option>
            ))}
            
          </select>
        </div>
      )}

      {/* Commission Rate (only shown if paySalesCommissions is true) */}
      {paySalesCommissions && (
        <div>
          <label className="block text-sm font-medium text-gray-700">Commissions Rate</label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <input
              type="number"
              step="0.01"
              {...register('commission_rate')}
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
              placeholder="0.00"
            />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
              <span className="text-gray-500 sm:text-sm">%</span>
            </div>
          </div>
        </div>
      )}

      {/* Calculate Overtime Based On */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Calculate Overtime Based On</label>
        <select
          {...register('overtime_based_on_id')}
          className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
        >
          <option value="" className='text-gray-400'>Select Option</option>
          {overtimeBasedOn?.map(overtime => (
            <option key={overtime.id} value={overtime.id}>{overtime.name}</option>
          ))}
          
        </select>
      </div>

      {/* Overtime 1 Starts After */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Overtime 1 Starts After</label>
        <div className="mt-1 relative rounded-md shadow-sm">
          <input
            type="number"
            {...register('overtime1_starts_after')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="0"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">
              {calculateOvertimeBasedOn === '1' ? 'hours/day' : 
               calculateOvertimeBasedOn === '2' ? 'hours/week' : 
               calculateOvertimeBasedOn === '3' ? 'hours/week' : ''}
            </span>
          </div>
        </div>
      </div>

      {/* Overtime 1 Rate */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Overtime 1 Rate</label>
        <div className="mt-1 relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">$</span>
          </div>
          <input
            type="number"
            step="0.01"
            {...register('overtime1_rate')}
            className="appearance-none block w-full pl-7 pr-12 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="0.00"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">/hour</span>
          </div>
        </div>
      </div>

      {/* Overtime 2 Starts After */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Overtime 2 Starts After</label>
        <div className="mt-1 relative rounded-md shadow-sm">
          <input
            type="number"
            {...register('overtime2_starts_after')}
            className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="0"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">
              {calculateOvertimeBasedOn === '1' ? 'hours/day' : 
               calculateOvertimeBasedOn === '2' ? 'hours/week' : 
               calculateOvertimeBasedOn === '3' ? 'hours/week' : ''}
            </span>
          </div>
        </div>
      </div>

      {/* Overtime 2 Rate */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Overtime 2 Rate</label>
        <div className="mt-1 relative rounded-md shadow-sm">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">$</span>
          </div>
          <input
            type="number"
            step="0.01"
            {...register('overtime2_rate')}
            className="appearance-none block w-full pl-7 pr-12 px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#009efb] focus:border-[#009efb] sm:text-sm"
            placeholder="0.00"
          />
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
            <span className="text-gray-500 sm:text-sm">/hour</span>
          </div>
        </div>
      </div>

      {/* Pay Product/Service Bonuses */}
      <div>
        <label className="block text-sm font-medium text-gray-700">Pay Product/Service Bonuses</label>
        <div className="mt-1">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              {...register('pay_product_service_bonuses')}
              className="rounded border-gray-300 text-[#009efb] focus:ring-[#009efb]"
            />
            <span className="ml-2 text-sm text-gray-600">Yes</span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default PayrollTab; 